// extracted by mini-css-extract-plugin
export default {"placeholder_container":"ContainerOfPlaceholders_placeholder_container__BLfpI"};